const bitsToKBits: (bits: number) => number = (bits: number) => bits / 1024;

export const getKBitsSpeedFromPlaylistBitrate: (bitrate: number) => number = (bitrate) => bitsToKBits(bitrate);
